import { render, staticRenderFns } from "./CandidatesNote.vue?vue&type=template&id=ef00d18e&scoped=true&lang=pug&"
import script from "./CandidatesNote.vue?vue&type=script&lang=js&"
export * from "./CandidatesNote.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesNote.vue?vue&type=style&index=0&id=ef00d18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef00d18e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VMenu,VSpacer,VTextarea})
